/** Base path for embedding MainLayout-style (auth) routes inside Community Admin. */
export const ADMIN_PLATFORM_ROUTE_PREFIX = "/admin/platform";

function normalizePlatformApiPath(apiPath: string): string {
  if (!apiPath) {
    return "/";
  }

  const normalized = apiPath.startsWith("/") ? apiPath : `/${apiPath}`;
  const lower = normalized.toLowerCase();

  // Backend menu payload sometimes sends short/typo user-management paths.
  if (lower === "/permision" || lower === "/permission") {
    return "/tenant/permission";
  }
  if (lower === "/roles" || lower === "/role") {
    return "/tenant/roles";
  }
  if (lower === "/users" || lower === "/user") {
    return "/tenant/users";
  }
  if (
    lower === "/user-permissions" ||
    lower === "/userpermissions" ||
    lower === "/user-permission"
  ) {
    return "/tenant/user-permissions";
  }

  return normalized;
}

export function toAdminPlatformPath(apiPath: string): string {
  const prefix = ADMIN_PLATFORM_ROUTE_PREFIX;
  if (!apiPath || apiPath === "/") {
    return prefix;
  }
  const normalized = normalizePlatformApiPath(apiPath);
  return `${prefix}${normalized}`;
}
